<template>
    <div>
        <breadcrumb :routerList="[{to:'/loud/loud',title:'信息漏斗'},{title:'区域机会'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <!--<el-form-item label="选择日期">
                            <el-date-picker
                                    :clearable="true"
                                    v-model="formInline.time"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    style="width: 1.5rem;">
                            </el-date-picker>
                        </el-form-item>-->
                        <el-form-item label="选择日期">
                            <el-col :span="11">
                                <el-date-picker
                                        :clearable="true"
                                        type="date"
                                        placeholder="选择时间"
                                        v-model="formInline.timeB"
                                        style="width: 100%;"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-col>
                            <el-col class="line h-txtCenter" :span="2">至</el-col>
                            <el-col :span="11">
                                <el-date-picker
                                        :clearable="true"
                                        type="date"
                                        placeholder="选择时间"
                                        v-model="formInline.timeE"
                                        style="width: 100%;"
                                        value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-col>
                        </el-form-item>
                        <el-form-item class="h-formBtnOut">
                            <el-button
                                    class="h-btn h-formBtn"
                                    @click="handleFilter">
                                检索
                            </el-button>
                            <el-button
                                    class="h-btn h-formBtn"
                                    @click="resetData"
                                    style="background-color:white;color:black;border:1px solid #d1d1d1">
                                重置
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
                            height="600"
							border
                            :summary-method="getSummaries"
                            show-summary
                            style="width: 100%">
                        <el-table-column
                                prop="code"
                                label="机会大类"
								 :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="chance_type" :v="scope.row.code"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="node1"
                                :label="nodeName1"
								 :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="node2"
                                :label="nodeName2"
								 :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="node3"
                                :label="nodeName3"
								 :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="node4"
                                :label="nodeName4"
								 :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="node5"
                                :label="nodeName5"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="node6"
                                :label="nodeName6"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="total"
                                label="合计">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import big from 'big.js'
    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                objectlists: [],
                formInline: {
                    timeB: '',
                    timeE: '',
                },
                nodeName1: '',
                nodeName2: '',
                nodeName3: '',
                nodeName4: '',
                nodeName5: '',
                nodeName6: '',
                tableData: [],
            }
        },
        mounted() {

        },
        created() {
            this.showJD();
        },
        methods: {
            handleFilter() {
                // var s = {
                //     time:this.formInline.time,
                // }
                var timeB = this.formInline.timeB;
                var timeE = this.formInline.timeE;
                ss.jihui.showType(timeB, timeE).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.setItemDate(this.tableData[i])
                    }
                    this.sumNum();
                })
            },
            resetData() {
                this.formInline.time = '';
                this.query();
            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                return sums;
            },
            query() {
                // var s = {
                //     time:this.formInline.time,
                // }
                var timeB = this.formInline.timeB;
                var timeE = this.formInline.timeE;
                ss.jihui.showType(timeB, timeE).then(rd => {
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        // this.setItemDate(this.tableData[i])
                        for (var j = 0; j < this.objectlists.length; j++) {
                            var ol = this.objectlists[j];
                            this.tableData[i]['node' + (j + 1)] = this.tableData[i].map[ol] || null;
                        }
                    }
                    this.sumNum();
                })
            },
            showJD() {
                ss.jihui.showJD().then(rd => {
                    rd.forEach((item, index) => {
                        this['nodeName' + (index + 1)] = item;
                        var a = item.split(":");
                        this.objectlists.push(a[0]);
                    })
                })
                this.query();
            },
            setItemDate(obj) {
                for (var j = 0; j < this.objectlists.length; j++) {
                    var ol = this.objectlists[j];
                    obj['node' + (j + 1)] = obj.map[ol] || null;
                }
            },
            sumNum(){
                this.tableData.forEach((item, index) => {
                    let tot = 0;
                    for (var i=0 ; i<13 ; i++) {
                        tot = new big(tot).plus(parseInt(item['node' + (i + 1)]) || 0);
                    }
                    item.total = parseInt(tot);
                })
            }
        }
    }
</script>
<style>
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
</style>